/**
 * Indicatif téléphonique du Burkina Faso (sans « + ») — aligné sur le backend
 * (`IKODDI_COUNTRY_NUMBER_CODE`, défaut « 226 »).
 */
const COUNTRY_CODE = '226'

/**
 * Normalise un numéro de téléphone vers la forme canonique « 226XXXXXXXX ».
 *
 * Miroir exact de la règle backend (`App\Support\Phone`) : seuls les chiffres
 * sont conservés, le préfixe international « 00 » et l'indicatif pays sont
 * retirés puis l'indicatif ré-ajouté une seule fois. Ainsi « +226 70 12 34
 * 56 », « 0022670123456 » et « 70 12 34 56 » désignent tous la même valeur —
 * celle stockée en base : login, unicité et recherche parlent la même langue.
 *
 * Une saisie sans aucun chiffre est renvoyée vide (le backend convertit les
 * chaînes vides en `null` — champ téléphone optionnel des formulaires staff).
 */
export function normalizePhone(phone: string | null | undefined): string {
  const digits = (phone ?? '').replace(/\D+/g, '')

  if (!digits) {
    return ''
  }

  let local = digits
  if (local.startsWith('00')) {
    local = local.slice(2)
  }
  if (local.startsWith(COUNTRY_CODE)) {
    local = local.slice(COUNTRY_CODE.length)
  }

  return COUNTRY_CODE + local
}
